import React, { useState } from 'react';
import { downloadPDF } from '../utils/pdfGenerator';
import { preloadFonts } from '../utils/pdfAssets';
import { validatePdfMakeFonts } from '../utils/pdfDebug';

const PdfTest: React.FC = () => {
  const [status, setStatus] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleGeneratePdf = async () => {
    try {
      setLoading(true);
      setStatus('Starting PDF generation process...');
      setError(null);
      
      
      // Manually preload fonts first
      setStatus('Preloading fonts...');
      await preloadFonts();
      
      // Debug pdfMake configuration
      setStatus('Checking pdfMake configuration...');
      
      // Validate fonts
      const fontValidation = validatePdfMakeFonts();
      
      if (!fontValidation.isValid) {
        setStatus('Font validation failed. See console for details.');
        setError(`Font validation issues: ${fontValidation.issues.join(', ')}`);
        
        // Try to fix common issues
        setStatus('Attempting to generate PDF anyway...');
      }
      
      // Prepare sample data for PDF generation
      const sampleData = {
        title: 'Sample Data Architecture',
        description: 'This is a sample data architecture design created with MetaRouter Architect.',
        author: 'John Doe',
        createdAt: new Date().toISOString(),
        projectId: 'proj-123456',
        nodeCount: 12,
        edgeCount: 15,
        sources: ['Google Analytics', 'Segment', 'Customer Database'],
        destinations: ['Snowflake', 'BigQuery', 'Redshift', 'Amplitude']
      };

      // Generate the PDF
      setStatus('Generating PDF...');
      await downloadPDF(sampleData);
      
      setStatus('PDF generated successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      setError(`Error: ${error instanceof Error ? error.message : String(error)}`);
      setStatus('Failed to generate PDF');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded shadow-sm">
      <h2 className="text-lg font-semibold mb-4">PDF Generation Test</h2>
      <p className="mb-4">
        Click the button below to generate a sample PDF with custom IBM Plex Sans fonts.
      </p>
      
      <button
        onClick={handleGeneratePdf}
        disabled={loading}
        className={`px-4 py-2 ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded transition-colors`}
      >
        {loading ? 'Generating...' : 'Generate Test PDF'}
      </button>
      
      {status && (
        <div className="mt-4 p-2 bg-gray-100 rounded">
          <p className="font-medium">Status:</p>
          <p>{status}</p>
        </div>
      )}
      
      {error && (
        <div className="mt-4 p-2 bg-red-100 text-red-800 rounded">
          <p className="font-medium">Error:</p>
          <p>{error}</p>
        </div>
      )}
      
      <div className="mt-4 text-sm text-gray-600">
        <p>Note: Check the browser console for detailed logs.</p>
      </div>
    </div>
  );
};

export default PdfTest;
